// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

export const projectEndClassificationSchema = z.enum([
  'renewed',
  'contraction',
  'churn',
]);

export type ProjectEndClassification = z.infer<
  typeof projectEndClassificationSchema
>;

export const PROJECT_END_CLASSIFICATIONS =
  projectEndClassificationSchema.options;

export const PROJECT_END_CLASSIFICATION_LABELS: Record<
  ProjectEndClassification,
  string
> = {
  renewed: 'Renewed',
  contraction: 'Contraction',
  churn: 'Churn',
};
